// extracted by mini-css-extract-plugin
export default {"icon":"ShopRedirectButton_icon__l1LsF"};